import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function MinimalLineTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-9 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <h1 className="text-xl font-semibold tracking-[0.15em] uppercase">{draft.full_name || "Your Name"}</h1>
      <p className="text-[11px] uppercase tracking-widest mt-1" style={{ color: accent }}>{draft.target_role}</p>
      <p className="text-slate-400 text-[11px] mt-2">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("   ")}</p>
      <div className="w-10 h-px bg-slate-300 my-5" />

      {draft.summary && (
        <div className="mb-5">
          <h2 className="text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-400 mb-2">Summary</h2>
          <p className="text-slate-700">{draft.summary}</p>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mb-5">
          <h2 className="text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-400 mb-2">Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mb-3">
              <p className="font-medium text-slate-800">{e.title}</p>
              <p className="text-slate-500 text-[12px]">{e.company} · {dateRange(e.start_date, e.end_date, e.current)}</p>
              <ul className="text-slate-600 mt-1 space-y-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>— {b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mb-5">
          <h2 className="text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-400 mb-2">Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — <span className="text-slate-500">{ed.school}</span></p>)}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mb-5">
          <h2 className="text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-400 mb-2">Skills</h2>
          <p className="text-slate-700">{draft.skills.join(", ")}</p>
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
